import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import Table from '../../utils/Table/Table';

const Courses = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const addButton = (
    <button className='outline-btn' onClick={() => navigate(pathname + '/add')}>
      Нэмэх
    </button>
  );

  const columns = [
    {
      Header: 'Гарчиг',
      accessor: 'title',
    },
    {
      Header: 'Нийтэлсэн огноо',
      accessor: 'created_at',
      Cell: ({ value }) => moment(value).format('YYYY/MM/DD'),
    },
  ];

  return (
    <Table
      currentHref={pathname}
      apiPath='/courses'
      apiSubPath={String(pathname).includes('free-course') ? '1' : '0'}
      addButton={addButton}
      columns={columns}
    />
  );
};

export default Courses;
